import { useEffect } from "react";

const {
    GoogleAnalyticTagID
} = window['runConfig'];

const GoogleAnalytic = (props) => {

    useEffect(() => {

        if (GoogleAnalyticTagID != undefined && GoogleAnalyticTagID != "") {

            const script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id=" + GoogleAnalyticTagID;
            script.async = true;

            const script2 = document.createElement("script");
            script2.textContent = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
            
                gtag('config', '`+ GoogleAnalyticTagID + `');
                `;

            document.body.appendChild(script);
            document.body.appendChild(script2);

        }


    }, [GoogleAnalyticTagID]);

    return (
        ""
    );
};

export default GoogleAnalytic;
